import { PATHS } from "@config";

export const checkPathsList = {
  listPagesCustomFooter: [
    PATHS.REGIST6,
    // PATHS.REGIST5,
    // PATHS.SEARCH_JOB,

    // PATHS.PROFILE,
    // PATHS.PASSWORD,
    // PATHS.USER_GUIDE,
    // PATHS.FAQ,
    // PATHS.SUMAJOB_TERM,
    // PATHS.PRIVACY_POLICY,
    // PATHS.PRINCIPLE,
    // PATHS.SALARY,
    // PATHS.ABOUT_TRANSFER,
    // PATHS.ABOUT_JOB,
    // PATHS.COMPANY,
    // PATHS.MYNO,
    // PATHS.NO_CORRESPOND,
    // PATHS.VIDEO,
    // PATHS.CONTACT,
    // PATHS.IMAGE_REGIST,
  ],
  listPageShowJob: [PATHS.HOME, PATHS.JOB_DETAIL],
  listPagesGetStaff: [
    PATHS.SETTING,
    PATHS.MY_CAR,
    PATHS.VIDEO,
    PATHS.MYNO,
    PATHS.PROFILE,
    PATHS.HOME,
    PATHS.REGIST_3,
  ],
  listPagesCheckStaff: [
    PATHS.WISH_LIST,
    PATHS.NEWS,
    PATHS.MESSAGES,
    PATHS.JOB_APPLY,
    PATHS.SETTING,
  ],
  listPagesGetBanner: [
    PATHS.JOB_APPLY,
    PATHS.JOB_PLAN,
    PATHS.JOB_RESULT_EMPLOYMENT,
    PATHS.JOB_RESULT_SALARY,
    PATHS.JOB_WORK,
    PATHS.HOME,
  ],
  listPagesRefreshStaffDetail() {
    return [...this.listPagesGetBanner, PATHS.SETTING, PATHS.PROFILE];
  },
  listPagesCustomGobackHeaderLeft: [
    PATHS.JOB_DETAIL,
    PATHS.NEWS_DETAIL,
    PATHS.MESSAGES_DETAIL,
    PATHS.APP_POLICY,
    PATHS.PROFILE,
    PATHS.PASSWORD,
    PATHS.USER_GUIDE,
    PATHS.FAQ,
    PATHS.SUMAJOB_TERM,
    PATHS.PRIVACY_POLICY,
    PATHS.PRINCIPLE,
    PATHS.SALARY,
    PATHS.ABOUT_TRANSFER,
    PATHS.ABOUT_JOB,
    PATHS.COMPANY,
    PATHS.MYNO,
    PATHS.NO_CORRESPOND,
    PATHS.VIDEO,
    PATHS.CONTACT,
    PATHS.IMAGE_REGIST,
    PATHS.REGIST_MENU,
    PATHS.REGIST_1,
    PATHS.REGIST_2,
    PATHS.REGIST_3,
    PATHS.MAKING_CONTRACT,
  ],
  listPagesNoCustomHeaderLeft() {
    return [...this.listPagesCheckStaff, ...this.listPagesRefreshStaffDetail(), PATHS.HOME];
  },
  listPagesCustomRefreshHeaderLeft: [PATHS.NEWS, PATHS.MESSAGES],
  listPageGetMstConfig: [
    PATHS.REGISTER,
    PATHS.REGIST_1,
    PATHS.REGIST_2,
    PATHS.REGIST_3,
    PATHS.SETTING,
    PATHS.JOB_DETAIL,
    PATHS.WISH_LIST,
    PATHS.REGIST_FOREIGNER,
    PATHS.OFFICIAL_REGIST_FOREIGNER,
  ],
  listPageNavigateToHome: [
    PATHS.FOREINGNER,
    PATHS.YOUNGER,
    PATHS.REGISTER,
    PATHS.REGIST_AGREE1,
    PATHS.REGIST_AGREE2,
  ],
  listPageHideHeader: [PATHS.REGIST5],
  listPageGetSalary: [PATHS.SALARY],
  listPageNoAuthShowButton: [PATHS.HOME, PATHS.JOB_DETAIL],

  listPageForeignerRegisterProcess: [
    PATHS.REGIST_FOREIGNER,
    PATHS.OFFICIAL_REGIST_FOREIGNER,
    PATHS.IMAGE_REGIST,
    PATHS.VIDEO,
  ],
  listPageNotShowNotificationModal: [
    PATHS.REGIST_FOREIGNER,
    PATHS.OFFICIAL_REGIST_FOREIGNER,
    PATHS.IMAGE_REGIST,
    PATHS.VIDEO,
    PATHS.REGISTER,
    PATHS.REGIST_1,
    PATHS.REGIST_2,
    PATHS.REGIST_3,
    PATHS.REGIST5,
    PATHS.REGIST6,
    PATHS.REGIST_AGREE1,
    PATHS.REGIST_AGREE2,
  ],
};

export const backList = {
  [PATHS.JOB_DETAIL]: PATHS.HOME,
  [PATHS.NEWS_DETAIL]: PATHS.NEWS,
  [PATHS.MESSAGES_DETAIL]: PATHS.MESSAGES,
  // back settings
  [PATHS.PASSWORD]: PATHS.SETTING,
  [PATHS.PROFILE]: PATHS.SETTING,
  [PATHS.USER_GUIDE]: PATHS.SETTING,
  [PATHS.FAQ]: PATHS.SETTING,
  [PATHS.SUMAJOB_TERM]: PATHS.SETTING,
  [PATHS.PRIVACY_POLICY]: PATHS.SETTING,
  [PATHS.PRINCIPLE]: PATHS.SETTING,
  [PATHS.ABOUT_TRANSFER]: PATHS.SETTING,
  [PATHS.ABOUT_JOB]: PATHS.SETTING,
  [PATHS.COMPANY]: PATHS.SETTING,
  [PATHS.SALARY]: PATHS.SETTING,
  [PATHS.MYNO]: PATHS.SETTING,
  [PATHS.VIDEO]: PATHS.SETTING,
  [PATHS.CONTACT]: PATHS.SETTING,
  [PATHS.IMAGE_REGIST]: PATHS.SETTING,
  [PATHS.REGIST_MENU]: PATHS.SETTING,
  [PATHS.APP_POLICY]: PATHS.SETTING,
  // back regist
  [PATHS.NO_CORRESPOND]: PATHS.REGIST_MENU,
  [PATHS.REGIST_1]: PATHS.REGIST_MENU,
  [PATHS.REGIST_2]: PATHS.REGIST_1,
  [PATHS.REGIST_3]: PATHS.REGIST_2,
  [PATHS.REGIST_FOREIGNER]: PATHS.REGISTER,
  // back login
  [PATHS.REGIST_AGREE1]: PATHS.LOGIN,
  [PATHS.REGIST_AGREE2]: PATHS.REGIST_AGREE1,
  // back history
  [PATHS.MAKING_CONTRACT]: -1,
};
